import type { FetchRequestError } from "@lib/errors";
import { FetchNotFoundError, FetchUnauthorizedError, FetchPasswordInvalidError, FetchSsoError } from "@lib/errors";
import { UNIDENTIFIED_ERROR } from "@lib/fetch";

const doNothing = () => {
  // no action
};

/**
 * Given a FetchRequestError, return a function that should be executed when the user clicks "OK" on the error modal
 */
export const getFetchErrorModalAction = (error: FetchRequestError): (() => void) => {
  if (error instanceof FetchNotFoundError) {
    return () => {
      window.history.back();
    };
  }
  if (error instanceof FetchUnauthorizedError) {
    return () => {
      window.history.back();
    };
  }
  if (error instanceof FetchPasswordInvalidError) {
    return () => {
      window.location.reload();
    };
  }
  if (error.status == UNIDENTIFIED_ERROR) {
    return () => {
      window.location.reload();
    };
  }
  if (error instanceof FetchSsoError) {
    return () => {
      window.location.reload();
    };
  }
  return doNothing;
};
